module.exports = "<app-page-contents [pageName]=\"pageName\"></app-page-contents>\n\n<!-- COL SX -->\n<div [ngClass]=\"'col-md-4'\">\n    <app-search-edition-form></app-search-edition-form>\n</div>\n<!-- END // COL SX -->\n\n<!-- COL CONTENT -->\n<div [ngClass]=\"'col-md-8'\">\n    <app-search-edition-results></app-search-edition-results>\n</div>\n<!-- END // COL CONTENT -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pages/page-search-edition/page-search-edition.component.html
// module id = ./src/app/components/pages/page-search-edition/page-search-edition.component.html
// module chunks = main